import { Box } from '@mui/material';
import type { PublicResultsLayout } from '../../types/domain';

interface LayoutPreviewProps {
  layout: PublicResultsLayout;
  size?: number;
}

/**
 * Miniaturni SVG nahled kazdeho layoutu (pro admin volbu).
 * Stylizovane, bez realnych dat.
 */
export const LayoutPreview = ({ layout, size = 100 }: LayoutPreviewProps) => {
  const vb = `0 0 120 80`;
  return (
    <Box sx={{ width: size * 1.5, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg viewBox={vb} width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="80" rx="6" fill="#F5F5F5" stroke="#E0E0E0" />
        {layout === 'CLASSIC' && (
          <>
            {[14, 26, 38, 50, 62].map((y, i) => (
              <g key={i}>
                <rect x="10" y={y} width="8" height="6" rx="1" fill={i === 0 ? '#FFD54F' : i === 1 ? '#B0BEC5' : i === 2 ? '#D4A373' : '#BDBDBD'} />
                <rect x="22" y={y} width="60" height="6" rx="1" fill="#CFD8DC" />
                <rect x="86" y={y} width="24" height="6" rx="1" fill="#90A4AE" />
              </g>
            ))}
          </>
        )}
        {layout === 'PODIUM' && (
          <>
            <rect x="8" y="30" width="28" height="38" rx="3" fill="#B0BEC5" />
            <rect x="46" y="18" width="28" height="50" rx="3" fill="#FFB300" />
            <rect x="84" y="38" width="28" height="30" rx="3" fill="#A0703A" />
            <rect x="16" y="40" width="12" height="3" fill="#fff" opacity="0.8" />
            <rect x="54" y="32" width="12" height="3" fill="#fff" opacity="0.8" />
            <rect x="92" y="48" width="12" height="3" fill="#fff" opacity="0.8" />
          </>
        )}
        {layout === 'SPLIT_VIEW' && (
          <>
            <rect x="6" y="8" width="52" height="64" rx="3" fill="#FFF" stroke="#BDBDBD" />
            <rect x="62" y="8" width="52" height="64" rx="3" fill="#FFF" stroke="#BDBDBD" />
            {[18, 30, 42, 54].map((y, i) => (
              <g key={i}>
                <rect x="10" y={y} width="44" height="6" rx="1" fill={i === 0 ? '#FFD54F' : '#CFD8DC'} />
                <rect x="66" y={y} width="44" height="6" rx="1" fill={i === 0 ? '#FFB300' : '#B0BEC5'} />
              </g>
            ))}
          </>
        )}
      </svg>
    </Box>
  );
};
